import { createEvent, createStore } from 'effector';
import { onAttachmentFullScreenChangeParams } from '@nx-frontend/shared/types/editor';

/**
 * This store contains information whether an attachment is opened in fullscreen now.
 * If no attachment is opened in fullscreen, the store will be null.
 */
export const $editorAttachmentFullscreen = createStore<onAttachmentFullScreenChangeParams | null>(null);
export const setAttachmentFullscreenEvent = createEvent<onAttachmentFullScreenChangeParams | null>();

$editorAttachmentFullscreen.on(setAttachmentFullscreenEvent, (_, payload) => payload);
